import styled from 'styled-components';

export const HeaderMainWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        margin-bottom: 5.5rem;
        align-items: center;

        @media(max-width:1023px){
            margin-bottom:1rem;
        }
    `,
);

export const LogoInfoWrap = styled.div(
  props => `
        width:60%;
        display: flex;
        align-items: center;
        @media(max-width:1023px){
            flex-direction: column;
            width:100%;
            padding: ${props.theme.spacing.large.l20};
        }
    `,
);

export const HeaderLogoWrap = styled.div(
  props => `
        display: flex;
        @media(max-width:1023px){
            width:100%;
            padding-bottom: ${props.theme.spacing.large.l20};
            border-bottom: 1px solid rgba(255, 255,255,0.2);
            justify-content: space-between;
        }
    `,
);

export const HeaderPartnerInfoWrap = styled.div(
  props => `
        display: flex;
        padding-left: ${props.theme.spacing.large.l35};
        align-items: center;
        @media(max-width:1023px){
            width:100%;
            padding-bottom: ${props.theme.spacing.base};
            padding-top: ${props.theme.spacing.base};
            padding-left: ${props.theme.spacing.base};
            border-bottom: 1px solid rgba(255, 255,255,0.2);
        }
    `,
);

export const PartnerImgWrap = styled.div(
  props => `
        display: flex;
        img{
            width:24px;
            height:24px;
            border:1px solid ${props.theme.colors.white.base};
            border-radius: 50%;
        }
        .marginLM10{
            margin-left: -${props.theme.spacing.base};
        }
    `,
);

export const PartnerInfoTextWrap = styled.div(
  props => `
        display: flex;
        padding-left: ${props.theme.spacing.small.s8};
    `,
);

export const PartnerInfoText = styled.p(
  props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.white.base};

        span{
            font-weight: bold;
        }
    `,
);

export const HeaderLoginWrap = styled.div(
  props => `
        width:40%;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        @media(max-width:1023px){
            display: none;
        }
    `,
);

export const HeaderLinkText = styled.a(
  props => `
        font-size: ${props.theme.font.base};
        color: ${props.theme.colors.white.base};
        padding: ${props.theme.spacing.base};
        text-decoration: none;
        text-transform: uppercase;
        cursor: pointer;
    `,
);

export const HeaderLoginLink = styled.a(
  props => `
        background-color: ${props.theme.colors.white.base};
        padding: ${props.theme.spacing.small.s7};
        border-radius: 2.5rem;
        font-size: ${props.theme.font.small.font11};
        color: #124980;
        font-weight: 900;
        text-transform: uppercase;
        cursor: pointer;
        display: flex;
        align-items: center;
        text-decoration: none;
        margin-left: 1rem;
    `,
);

export const HeaderLoginLinkMob = styled.a(
  props => `
        display: none;
        @media only screen and (max-width:1023px){
            background-color: ${props.theme.colors.white.base};
            padding: ${props.theme.spacing.small.s7};
            border-radius: 2.5rem;
            font-size: ${props.theme.font.small.font11};
            color: #124980;
            font-weight: 900;
            text-transform: uppercase;
            cursor: pointer;
            display: flex;
            align-items: center;
            text-decoration: none;
            margin-left: 1rem;
        }
        
    `,
);

export const HeaderLangSelectorMob = styled.a(
  props => `
        display: none;
        @media only screen and (max-width:1023px){
            padding: ${props.theme.spacing.small.s7};
            border-radius: 2.5rem;
            font-size: ${props.theme.font.small.font11};
            color: #124980;
            font-weight: 900;
            text-transform: uppercase;
            cursor: pointer;
            display: flex;
            align-items: center;
            text-decoration: none;
            margin-left: 1rem;
        }
        
    `,
);
